import { MainLayout } from "./components/Layout/MainLayout";
// import { LoadingOverlay } from "./components/LoadingOverlay/LoadingOverlay";
import "./index.css";

function App() {
  return (
    <>
      {/*<LoadingOverlay />*/}
      <MainLayout />
    </>
  );
}

export default App;
